// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
import showQrCodeIcon from "../assets/eye.png";
import AuthRequiredService from "./base.js";
import { LoginConfig } from "./config/login-config.js";

class MFAService extends AuthRequiredService {
  constructor() {
    super();
  }

  generateMfaImage() {
    return super
      .useApiClient()
      .get("/api/v1/mfa", { responseType: "blob" });
  }

  verifyMfaCode(code) {
    const payload = JSON.stringify({ code });
    return super
      .useApiClient()
      .post("/api/v1/mfa", payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });
  }

  fetchSystemInfos({ lang }) {
    return super
      .useApiClient()
      .get("/api/v1/systemInfos", { headers: { "Accept-Lang": lang } });
  }

  showMfaConfig() {
    const accessToken = window.localStorage.getItem("accessToken");
    const payload = jwt_decode(accessToken);
    // console.log(payload);
    return this.generateMfaImage().then(res => {
      const url = URL.createObjectURL(res.data);
      const mfaEnabled = payload.mfa_enabled;
      // const mfaEnabled = true;
      const title = mfaEnabled ? "MFA Code Verification" : "MFA Setting & Login";

      Swal.fire({
          html: `
          <div style="margin:10px;">
              <h1 style="text-align: left; font-size: 24px;">${title}</h1>
          </div>
          <div style="margin:10px;" class="${mfaEnabled ? "hidden" : ""}">
              <p style="text-align: left; font-size: 20px;">Set up the MFA to better protect your account.</p>
          </div>
          <div style="display: ${mfaEnabled ? "none" : "inline-flex"}">
              <!-- MFA註冊說明文字 -->
              <div style="font-size:18px; margin-left: 20px; flex:2;">
                  <ol style="list-style: auto;">
                      <li style="text-align: left; margin: 10px;">Install a MFA app on your mobile device or computer.</li>
                      <li style="text-align: left; margin: 10px;">Use your MFA app through your device's camera to scan this QR code.</li>
                      <!--<li style="text-align: left; margin: 10px;">Type MFA codes below.</li>-->
                  </ol>
              </div>
              <!-- 產生 MFA api -->
              <div style="flex: 1.5; margin-top: -9px; margin-left: 5px;">
                  <img src="${url}"
                  style ="width: 200px;
                  height: 200px;"/>
              </div>
          </div>
          <div style="display: ${mfaEnabled ? "inline-flex" : "none"}">
            <div style="font-size:18px; margin-left: 20px; flex:2;">
              <ul style="list-style: disc;">
                <li style="text-align: left; margin: 10px;">
                  <div style="display: flex; align-items: center;">
                    If you want to rebinding the MFA, please click the button.   
                    <button type="button" style="width: 25px;" onclick="(qrcode.style.maxHeight = qrcode.style.maxHeight === '0px' ? '200px' : '0px')">
                      <img style="margin-left: 5px;" src="${showQrCodeIcon}"/>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div style="display: flex; justify-content: center; flex: 1.5; margin-top: -9px; margin-left: 5px; ">
              <img src="${url}"
                id="qrcode"
                style ="width: 200px; height: 200px; display: block; max-height: 0px; transition: .25s max-height"
              />
          </div>
          <div style="display: inline-flex">
              <div style="margin-top: 35px;">
                  <p>MFA Code:</p>
              </div>
              <div style="flex: 2;">
                  <!-- 使用者輸入 MFA code -->
                  <input placeholder="6 numbers code" id="swal-input1" class="swal2-input" @keyup="handleEnterPress">
              </div>
          </div>
        `,
        width: "36rem",
        confirmButtonText: "Verify",
        showLoaderOnConfirm: true,
        // 阻擋模態關閉(測試時建議註解，不然很麻煩)
        allowOutsideClick: false,
        showCloseButton: true,
        focusConfirm: false,
        didOpen: () => {
          const inputElement = document.getElementById("swal-input1");
          inputElement.focus();
          inputElement.addEventListener("keyup", event => {
            if (event.key === "Enter") {
              Swal.clickConfirm();
            }
          });
        },
        preConfirm: confirm => {
          // 如果 confirm 為空值，直接返回
          if (!confirm) return;

          // 獲取輸入框中的 MFA 驗證碼
          const mfaCode = document.getElementById("swal-input1").value;
          // 調用 MFAService 的 verifyMfaCode 方法進行驗證，返回一個 Promise
          return this.verifyMfaCode(mfaCode).then(res => {
              // 判斷 MFA 驗證是否成功
              const isSuccees = res.status === 200;
              // 如果驗證失敗，顯示錯誤提示
              if (!isSuccees) {
                  Swal.showValidationMessage("MFA Verification Failed");
                  return;
              }
              // 如果驗證成功
              // 登入從後端拿取 token  localStorage
              // 將token存儲在localStorage中
              window.localStorage.setItem("accessToken", res.data.access_token);
              //將使用者跳轉至首頁
              window.location.href = `${LoginConfig.indexPageURL}`;
            }).catch(() => {
              // 如果 Promise 被拒絕，顯示錯誤提示
              Swal.showValidationMessage("MFA Verification Failed");
            });
          }
      });
    }); 
  }
}

export default new MFAService();
